import React from 'react';
import { InterviewPrep as InterviewPrepComponent } from '../components/interview/InterviewPrep';

export const InterviewPrepPage: React.FC = () => {
  return <InterviewPrepComponent />;
};